package com.eladfinish.bible.contest.extensions

import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontFamily
import com.eladfinish.bible.contest.text.SpannableStringKMP
import com.eladfinish.bible.contest.utils.RegexUtils

fun AnnotatedString.withContinuousUnderlined(): AnnotatedString =
    buildAnnotatedString {
        append(this@withContinuousUnderlined)
        RegexUtils.UNDERSCORES.toRegex().findAll(this@withContinuousUnderlined.text).forEach {
            addStyle(SpanStyle(fontFamily = FontFamily.Serif), it.range.first, it.range.last + 1)
        }
    }

fun SpannableStringKMP.toAnnotatedStringWithContinuousUnderlined(): AnnotatedString {
    return AnnotatedString(
        text = this.charSequence.toString(),
        spanStyles = this.spannedRangeList.map {
            AnnotatedString.Range(
                item = SpanStyle(fontFamily = FontFamily.Serif),
                start = it.textRange.start,
                end = it.textRange.end,
            )
        },
    )
}
